import { SmartTable } from '../../../../components/smart-table/smart-table.model';

/** @ngInject */
export class Controller{

    /** @ngInject */
    constructor($state,ResellerCompanyResource,Alert) {
        this.$state = $state;
        this.ResellerCompanyResource = ResellerCompanyResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.createdCompany) {
            this.$state.go('^', {}, {location: 'replace'})
        }
        const companyId = this.companyId;
        this.stAdministrators = new SmartTable();
        this.saaspassId = this.account.login;
        const filteredAdmins = this.administrators.filter(o => o.saaspassId !== this.saaspassId);
        this.filteredAdmins = filteredAdmins;


    }
    gotoNewCompany(){
        this.$state.go('company.landing-page', {companyId: this.createdCompany.companyId});
    }


    addAdministrators(administrators){
        this.ResellerCompanyResource.addAdministrators(this.companyId, this.createdCompany.companyId, administrators).then((data)=>{
                this.$state.go('company.reseller.list');
                this.Alert('success', 'company.reseller.new-company.add-administrators-success');
            }
        )
    }

}


// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/new-company/new-company.controller.js